module.exports = __webpack_public_path__ + "static/media/veneto-village-20.7ef3c62b.jpg";